import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => {
    const out = () => {
      setUser((u) => {
        if (u) toast.info("Session expired. Please sign in again.");
        return false;
      });
    };
    window.addEventListener("ac-logout", out);
    return () => window.removeEventListener("ac-logout", out);
  }, []);

  const accept = (data) => {
    localStorage.setItem("ac_token", data.token);
    if (data.refresh_token) localStorage.setItem("ac_refresh", data.refresh_token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => accept((await api.post("/auth/login", { email, password })).data);
  const register = async (body) => accept((await api.post("/auth/register", body)).data);
  const supplierApply = async (body) => accept((await api.post("/auth/supplier-apply", body)).data);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("ac_token");
    localStorage.removeItem("ac_refresh");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login, register, supplierApply, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);

export const homeFor = (u) => (u?.role === "admin" ? "/admin" : u?.role === "supplier" ? "/supplier" : "/portal");
